import { useAppDispatch, useAppSelector } from '@store/hooks'
import { updateMembershipProfile } from '@store/membership/MembershipProfileReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import dayjs from 'dayjs'
import { forwardRef } from 'react'
import Update from './Update'

export const MembershipProfileForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.membershipProfile)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          update: Update,
        }}
        handlers={{
          update: async (values: any) => {
            return dispatch(
              updateMembershipProfile({
                ...values,
                birthDate: dayjs(values.birthDate).format('YYYY-MM-DD'),
              })
            ).then(() => {
              return true
            })
          },
        }}
      />
    )
  }
)

MembershipProfileForm.displayName = 'MembershipProfileForm'

export default MembershipProfileForm
